<template lang="pug">
  tr
    td.font-weight-bold(width=200) {{label}}
    td
      slot
</template>

<script>
export default {
  props: [ 'label' ]
}
</script>